<template lang="html">
  <section class="vh intro">
    <a href="#" v-scroll-to="'.excelencia'" class="scrolldown"></a>
    <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">
      <div class="container-text">
        <div v-html="$t('home.excelencia.intro')"></div>
        <p v-html="$t('home.excelencia.texto')"></p>
        <div class="flex align-center pdfs">
          <router-link class="link" :to="$t('enlaces.certificado_IATF_16949')" target="_blank">
            {{ $t('enlaces.textos.certificado_IATF_16949') }}
          </router-link>
          <router-link class="link" :to="$t('enlaces.certificado_ISO_9001')" target="_blank">
            {{ $t('enlaces.textos.certificado_ISO_9001') }}
          </router-link>
          <router-link class="link" :to="$t('enlaces.certificado_ISO_14001')" target="_blank">
            {{ $t('enlaces.textos.certificado_ISO_14001') }}
          </router-link>
        </div>
        <div class="flex align-center container-actions">
          <router-link class="btn btn-light open-pop -yellow" :to="$t('enlaces.contacto')">{{
            $t('enlaces.textos.contacto') }}</router-link>
          <router-link class="btn btn-light open-pop -yellow" :to="$t('enlaces.catalogo')">{{
            $t('enlaces.textos.catalogo') }}</router-link>
        </div>
      </div>
    </div>
    <video loop autoplay muted="true" class="video-bkg" id="video">
      <source src="/static/video/video-productos-intro.mp4" type="video/mp4">
    </video>
  </section>
</template>

<script lang="js">

export default {
  name: 'home',
  props: [],
  data() {
    return {
    }
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/home.vue